import {NONE_STATUS, PENDING_STATUS, SUCCESS_STATUS} from "../../actions";
import axios from "axios";
import {getLikeMediaUrl, getLikeSpaceMediaUrl} from "../../actions/environment";
import {authConfig} from "../../actions/local-storage";
import {useState} from "react";
import useErrorHandler from "./use-error-handler";
import {useAuthorization} from "../../selectors";

/**
 * helper hook for creating and updating media synchronously (without redux)
 * -- refactor to use media calls instead of spacemedia which is deprecated --
 */
const useUpdateMediaLike = () => {
    const [status, setStatus] = useState(NONE_STATUS);
    const [media, setMedia] = useState(null);
    const {principalUsername} = useAuthorization();
    const {handleError, error} = useErrorHandler(setStatus);

    // currently using media useState for both spacemedia and media -- refactor --
    const updateSpaceMediaLike = (spaceId, mediaId, callback) => {
        setStatus(PENDING_STATUS);
        axios.put(getLikeSpaceMediaUrl(principalUsername, spaceId, mediaId), null, authConfig())
            .then(response => {
                setMedia(response.data);
                setStatus(SUCCESS_STATUS);
                callback && callback(response.data);
            })
            .catch(error => {
                console.log('updateSpaceMedia error', error);
                handleError(error, () => updateSpaceMediaLike(spaceId, mediaId, callback));
            })
    }

    // currently using media useState for both spacemedia and media -- refactor --
    const updateMediaLike = (spaceId, mediaId, callback) => {
        setStatus(PENDING_STATUS);
        axios.put(getLikeMediaUrl(principalUsername, spaceId, mediaId), null, authConfig())
        .then(response => {
            setMedia(response.data);
            setStatus(SUCCESS_STATUS);
            callback && callback(response.data);
        })
        .catch(error => {
            console.log('updateMedia error', error);
            handleError(error, () => updateMediaLike(spaceId, mediaId, callback));
        })
    }


    return {
        updateSpaceMediaLike: updateSpaceMediaLike,
        updateMediaLike: updateMediaLike,
        media, status, error}
}

export default useUpdateMediaLike;